export const SITE_TYPE_MEDIX = 'medix' as const;
export const SITE_TYPE_HITOWA = 'hitowa' as const;
export const SITE_TYPE_UPSYSTEM = 'upsystem' as const;

/**
 * サイト区分 display labels.
 *
 * Note this is the *business* vocabulary (upsystem reads as 個人請求), not the
 * brand names. It was copy-pasted identically into ClinicBasicInfo,
 * DeleteClinicTable and OrderRezeptSheetEditPage; those now share this map.
 *
 * Two other vocabularies exist on purpose and are NOT merged here:
 * - 管理サイト in `AdminUserListTable` (adds `super-admin`, upsystem reads as メディックス)
 * - brand names on the site-admin login screen (Medix / Hitowa)
 */
export const SITE_TYPE_LABELS: Record<string, string> = {
  [SITE_TYPE_MEDIX]: 'メディックス',
  [SITE_TYPE_UPSYSTEM]: '個人請求',
  [SITE_TYPE_HITOWA]: 'Hitowa',
};

/** Short サイト区分 code for dense tables and printed artefacts. */
export const SITE_TYPE_SHORT_CODES: Record<string, string> = {
  [SITE_TYPE_MEDIX]: 'MDX',
  [SITE_TYPE_HITOWA]: 'HTW',
  [SITE_TYPE_UPSYSTEM]: '個人',
};

/** サイト区分 label, falling back to the raw value for unknown site types. */
export const getSiteTypeLabel = (siteType?: string | null): string =>
  (siteType && SITE_TYPE_LABELS[siteType]) || siteType || '';

/** Short サイト区分 code, or `undefined` when the site type has none. */
export const getSiteTypeShortCode = (siteType?: string | null): string | undefined =>
  siteType ? SITE_TYPE_SHORT_CODES[siteType.toLowerCase()] : undefined;
